import { render, staticRenderFns } from "./QuotaSettingsModal.vue?vue&type=template&id=4964d137"
import script from "./QuotaSettingsModal.vue?vue&type=script&lang=js"
export * from "./QuotaSettingsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports